import input from "./input";
import form from "./form";

export default {
    input,
    form,
};
